import { DISPLAY } from "@pearsontechnology/bronte-lib-math/readonly";

const SLATE_MATHML_FIELD = "mathML";

/**
 * Object with the shape `makeMathRenderer` expects for resolving MathML from
 * `state().get()` in BV Express (read-only; no live courseware).
 */
export function createReadonlyMathStateAdapter(mathMl: string) {
  return {
    state: (_path: string) => ({
      get: async () => mathMl,
    }),
    courseware: (_id: string) => ({
      state: (_p?: string) => ({
        get: async () => null,
      }),
    }),
  };
}

/**
 * Options for readonly `makeMathRenderer`. Property names are defined by
 * `@pearsontechnology/bronte-lib-math` — do not rename keys here.
 */
export function buildReadonlyMathRendererOptions(isBlock: boolean) {
  return {
    cdpPath: SLATE_MATHML_FIELD,
    display: isBlock ? DISPLAY.BLOCK : DISPLAY.INLINE,
  };
}
